module.exports = __webpack_public_path__ + "static/media/HomeTab8.427a4414.jpg";